<mat-form-field class="select" appearance="outline">
  <mat-label>{{
    "features.product-comparison.selectLabelClaasProduct" | translate
  }}</mat-label>
  <mat-select
    (selectionChange)="handleProductSelectChange($event)"
    [value]="$safeNavigationMigration(selectedProductDescendant()?.ID)"
  >
    @for (
      productDescendant of productDescendants();
      track productDescendant.ID
    ) {
      <mat-option class="option font-xs" [value]="productDescendant.ID">{{
        productDescendant.Name
      }}</mat-option>
    }
  </mat-select>
</mat-form-field>

<claas-main-modal-dialog
  [canBeDismissed]="false"
  [(show)]="showIncomparableModal"
>
  <claas-competitor-selection-dialog
    (closeCompetitorsDialog)="handleCompetitorSelectValueChange($event)"
    [userSelectedProductDetailID]="userSelectedProduct()"
  ></claas-competitor-selection-dialog>
</claas-main-modal-dialog>
